import { FC } from 'react';
import { TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Box, Typography } from '@mui/material';

import Utils from '../../../../../components/Utils';
import { CampaignAdGroup } from '../../../../../types/Campaign';

interface LinkedAdGroupsTableProps {
    adGroups: CampaignAdGroup[];
}

const CampaignFlightAdGroupGrid: FC<LinkedAdGroupsTableProps> = ({ adGroups }) => {
    if (!adGroups || adGroups.length === 0) {
        return (
            <Box sx={{ p: 3, textAlign: 'center' }}>
                <Typography variant="body2" color="text.secondary">
                    No linked ad groups found
                </Typography>
            </Box>
        );
    }

    return (
        <TableContainer sx={{ border: 1, borderColor: 'divider', borderRadius: 1 }}>
            <Table>
                <TableHead>
                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell>Ad Group Name</TableCell>
                        <TableCell align="right">DSP Budget</TableCell>
                        <TableCell align="right">Start Date</TableCell>
                        <TableCell align="right">End date</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {adGroups.map((adGroup) => (
                        <TableRow key={adGroup.id}>
                            <TableCell component="th" scope="row">
                                <Typography
                                    variant="body2"
                                    sx={{
                                        maxWidth: '400px',
                                        overflow: 'hidden',
                                        textOverflow: 'ellipsis',
                                        whiteSpace: 'nowrap',
                                    }}
                                    title={adGroup.name}
                                >
                                    {adGroup.name}
                                </Typography>
                            </TableCell>
                            <TableCell align="right">
                                {adGroup.budgetAmount ? Utils.formatCurrency(adGroup.budgetAmount) : '-'}
                            </TableCell>
                            <TableCell align="right">{Utils.formatESTDate(adGroup.startDateTime)}</TableCell>
                            <TableCell align="right">{Utils.formatESTDate(adGroup.endDateTime)}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};

export default CampaignFlightAdGroupGrid;
